var React = require('react');

function Silhouette (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a{fill:none;stroke:#97a6aa;stroke-linejoin:round;stroke-width:1.5px;}")),React.createElement("g",{"transform":"translate(0.75 0.75)","key":1},[React.createElement("path",{"className":"a","d":"M9.5,13.2V16L4.491,17.789A3,3,0,0,0,2.5,20.614V22.5h19V20.614a3,3,0,0,0-1.991-2.825L14.5,16V13.2","transform":"translate(-2.5 -2)","key":0}),React.createElement("ellipse",{"className":"a","cx":"5","cy":"6","rx":"5","ry":"6","transform":"translate(4.5)","key":1}),React.createElement("path",{"className":"a","d":"M16.953,7.453c-.168.021-.284.014-.453.047-1.7.328-2.8-.289-3.734-1.93A4.63,4.63,0,0,1,9,7.5a4.019,4.019,0,0,1-1.936-.466","transform":"translate(-2.5 -2)","key":2})])]);
}

Silhouette.defaultProps = {"width":"20.5","height":"22","viewBox":"0 0 20.5 22"};

module.exports = Silhouette;

Silhouette.default = Silhouette;
